<template>
    <div>
      <iframe :src="url" width="100%" height="700px"></iframe>
    </div>
</template>

<script>
export default {
  methods: {
    
  },
  created() {
    const fileName = this.$route.query.fileName;
    const year = this.$route.query.year;
    this.url=this.url+year+'/'+fileName;
    
    console.log(this.url);
  },
  data() {
    return {
      url:'http://111.47.28.118:9100/forecast/forecast/pdfView?fileName='
    };
  },
};
</script>